<template>
  <nav class="nav">
    <div class="container">
      <div class="logo">
        <img :src="systemLogoUrl" class="lookdeep-logo" />
      </div>
      <div class="nav__right" id="nav__right">

      </div>
    </div>
  </nav>
</template>

<script>
import systemLogoUrl from "@/assets/ld-logo.png";

export default {
  name: "PublicHeaderBar",
  data() {
    return {
      systemLogoUrl
    }
  }
}
</script>

<style scoped lang="scss">
.nav {
  width: 100%;
  border-bottom: 1px solid var(--ld-border-default);
  background: $background-level-1;
}
.nav > .container {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo {
  display: flex;
}
img.lookdeep-logo {
  width: 180px;
  max-height: none;
  @include mobile {
    width: 130px;
  }
}

.layout__header {
  display: flex;
}
</style>
